// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"fe02b1e3","513":"ec61e50a","787":"92af229c"}[chunkId] + ".chunk.js";
};